var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","total":_vm.pageInfo.total,"page-size":_vm.pageInfo.pageSize},on:{"current-change":_vm.handlePageChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }